<template>
    <div
    class="collapsible-divider-wrapper"
    :class="{'hide-content': collapse, 'double-column': doubleColumn, 'mobile': getMobileAppState}">
        <button-section
        :label="titleToDisplay"
        :removeBorder="removeBorder"
        :isOpen="!collapse"
        :variant="variant"
        @clicked="collapse = !collapse"/>
        <!-- Slot for content -->
        <slot v-if="!collapse"></slot>
    </div>
</template>

<script setup>
import ButtonSection from '@/components/generic/buttons/Section'
import { ref, computed } from 'vue'

/* Store */
import { mapGetters } from '@/store/helpers/mappers'

/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

/* mapActions & mapGetters */
const { getMobileAppState } = mapGetters()

/** props received
@title { String }
@openTitle { String } - title for when is open, if needed
@oneTitleOnly {Boolean} - prop to show always the title even if component is open
@removeBorder { Boolean }
@startClosed { Boolean } - prop for component to start closed
@doubleColumn { Boolean } - to divide content in two columns
@variant {String} can be [generic (default), primary]
*/
const props = defineProps({
	title: String,
    openTitle: String,
    oneTitleOnly: Boolean,
    removeBorder: Boolean,
    startClosed: Boolean,
    doubleColumn: Boolean,
    variant: String
})

const collapse = ref(props.startClosed || false)

const titleToDisplay = computed(() => {
    if (props.oneTitleOnly) return props.title
    return collapse.value ? props.title || t('textBlocks.showDetails') : props.openTitle || t('textBlocks.hideDetails')
})
</script>

<style lang="scss" scoped>
.collapsible-divider-wrapper {
    width: 100%;

    display: flex;
    flex-direction: column;
    gap: 24px;

    &.hide-content {
        height: 48px;
        overflow: hidden;
    }

    &:not(.mobile) {
        &.double-column {
            width: 100%;

            display: grid;
            grid-template-columns: auto auto;

            :deep(.button-section), :deep(.infobox-generic-wrapper) {
                grid-column-end: span 2;
            }
        }
    }

    &.prevent-auto-margins {
        > :deep(*) {
            &:not(.prevent-auto-margins) {
                width: calc(100% - 32px);
                margin-left: auto;
                margin-right: auto;
            }
        }
    }
}
</style>
